import { render } from "./admit_patient_modal.vue?vue&type=template&id=38b9686d&scoped=true"
import script from "./admit_patient_modal.vue?vue&type=script&lang=js"
export * from "./admit_patient_modal.vue?vue&type=script&lang=js"

import "./admit_patient_modal.vue?vue&type=style&index=0&id=38b9686d&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b9686d"]])

export default __exports__